module.exports = __webpack_public_path__ + "img/cbattery_ca.5a404096.jpg";